import { memo } from 'react'
import { Stack } from '@mui/material'
import { Document } from '@/types/documents'
import FlagsIndicator from '../flags/FlagsIndicator'

type DocumentRowIndicatorsProps = {
  document: Document
}

const defaultFlagCount = { error: 0, warning: 0, info: 0, failure: 0 }

const DocumentRowIndicators = ({ document }: DocumentRowIndicatorsProps) => {
  const {
    document_flags__count = defaultFlagCount,
    document_rows__document_row_values__row_value_flags__count = defaultFlagCount,
  } = document

  const totalFlagsCount = [
    ...Object.values(document_flags__count),
    ...Object.values(
      document_rows__document_row_values__row_value_flags__count,
    ),
  ].reduce((a, b) => a + b, 0)

  const indicators = []

  if (totalFlagsCount > 0)
    indicators.push(
      <FlagsIndicator
        key="flag-indicator"
        documentId={document.id}
        flagsCount={{
          documentFlags: document_flags__count,
          rowsFlags: document_rows__document_row_values__row_value_flags__count,
        }}
      />,
    )

  return (
    <Stack direction="row" alignItems="center">
      {indicators}
    </Stack>
  )
}

export default memo(DocumentRowIndicators)
